function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { Icon } from '@doordash/design-language';
import Menu from '@doordash/component-menu';

var ActionMenu = function ActionMenu(_ref) {
  var row = _ref.row,
      menuItems = _ref.menuItems,
      toggleRowSelection = _ref.toggleRowSelection,
      onMenuItemClick = _ref.onMenuItemClick,
      menuContainerStyles = _ref.menuContainerStyles,
      selectedRows = _ref.selectedRows;

  var _React$useState = React.useState(function () {
    return false;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      menuOpenState = _React$useState2[0],
      setMenuOpenState = _React$useState2[1];

  menuItems = menuItems.filter(function (menuItem) {
    return !(menuOpenState && row.isMenuOpen && menuItem.hideItem && menuItem.hideItem(row, selectedRows));
  });
  var menu = menuItems.map(function (menuItem) {
    return {
      id: menuItem.id,
      title: menuItem.title,
      onClick: function onClick() {
        setMenuOpenState(false);
        onMenuItemClick(menuItem.id);
      }
    };
  });
  return /*#__PURE__*/React.createElement(Menu, {
    interactionType: Menu.InteractionTypes.Controlled,
    isVisible: row.isMenuOpen && menuOpenState,
    onVisibilityChange: function onVisibilityChange(isVisible) {
      setMenuOpenState(isVisible);
      row.isMenuOpen = isVisible;
    },
    alignMenu: Menu.MenuAlignments.BottomLeft,
    menuContainerStyles: menuContainerStyles,
    content: menu,
    renderMenuControl: function renderMenuControl(_ref2) {
      var describedBy = _ref2.describedBy,
          accessibilityAttributes = _ref2.accessibilityAttributes;
      return /*#__PURE__*/React.createElement(Icon, _extends({
        type: Icon.Types.MoreVertical,
        size: Icon.Sizes.Medium,
        onClick: function onClick() {
          setMenuOpenState(!menuOpenState);
          toggleRowSelection();
        },
        "aria-describedby": describedBy
      }, accessibilityAttributes));
    }
  });
};

export default ActionMenu;